export const SpielgruppePlusEditorToolbarConfig = {
  options: ["inline", "textAlign", "list", "colorPicker", "link", "emoji", "remove"],
  inline: { inDropdown: true },
  list: { inDropdown: true },
  textAlign: { inDropdown: true },
  link: { inDropdown: true }
};
